import { SquareArrowOutUpRight } from 'lucide-react';

import { KeyValuePair, MutedBox, PostSectionTitle } from './post-section-components';

import type { Post } from '@/entities/post/post-types';
import { Button } from '@/shared/components/shadcn/button';
import { Separator } from '@/shared/components/shadcn/separator';
import { getCountryName } from '@/shared/utils/get-country-name';

export const PostProfile = ({ post }: { post: Post }) => {
  const handleGoToProfile = () => {
    window.open(post.author.profile_url, '_blank', 'noopener,noreferrer');
  };
  if (!post.author) return null;

  const age = () => {
    const age = post.analyzation?.demographic?.age;
    if (age) {
      if (age < 0) return 'Unknown';
      return age.toString();
    }
    return 'Unknown';
  };
  return (
    <MutedBox className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <PostSectionTitle>Profile & demographics</PostSectionTitle>
        <Button variant="outline" size="sm" onClick={handleGoToProfile}>
          <SquareArrowOutUpRight size={16} />
          Go to profile
        </Button>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <KeyValuePair label="Author" value={post.author.username} />
        <KeyValuePair label="Nickname" value={post.author.nickname} />
      </div>
      <Separator className="my-2" />
      <div className="grid grid-cols-2 gap-6">
        <KeyValuePair label="Gender" value={post.analyzation?.demographic?.gender || '-'} />
        <KeyValuePair label="Race" value={post.analyzation?.demographic?.race || '-'} />
        <KeyValuePair label="Age" value={age()} />
        <KeyValuePair label="Location" value={getCountryName(post.extraction.location) || '-'} />
      </div>
    </MutedBox>
  );
};
